import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { InvestmentType, PagedResponseInvestmentType } from '../models/InvestmentType';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class InvestmentTypeService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getInvestmentTypes():Observable<PagedResponseInvestmentType>{
    const data =  this.http.get<PagedResponseInvestmentType>(this.APIURL+'/InvestmentType' + '?PageNumber=1&PageSize=100');
    this.messageService.add('InvestmentType Service: fetched InvestmentTypes');
    return data;
  }

  getInvestmentType(id: number): Observable<InvestmentType> {
        const InvestmentType =this.http.get<InvestmentType>(this.APIURL+'/InvestmentType/' + id);
    this.messageService.add(`InvestmentType Service: fetched InvestmentType with id=${id}`);
    return InvestmentType;
  }
}